module.exports = __webpack_public_path__ + "static/media/spinner.64ceb76b.gif";